import { z } from "zod";

// Feature 018: classification backfill endpoint contracts.
// See specs/018-invoice-client-classification/contracts/backfill-classification.contract.md

export const BackfillClassificationRequestSchema = z.object({
  batch_size: z.number().int().min(1).max(200).default(50),
  cursor: z.string().uuid().nullable().default(null),
});
export type BackfillClassificationRequest = z.infer<typeof BackfillClassificationRequestSchema>;

export const BackfillFailureReasonSchema = z.object({
  ksef_retention: z.number().int().min(0),
  ksef_auth: z.number().int().min(0),
  ksef_other: z.number().int().min(0),
  subiekt_not_found: z.number().int().min(0),
  subiekt_auth: z.number().int().min(0),
  subiekt_other: z.number().int().min(0),
  no_account_in_data: z.number().int().min(0),
  no_external_source: z.number().int().min(0),
});
export type BackfillFailureReason = z.infer<typeof BackfillFailureReasonSchema>;

export const BackfillTotalsSchema = z.object({
  sales_total: z.number().int().min(0),
  sales_with_bank_account: z.number().int().min(0),
  sales_without_bank_account: z.number().int().min(0),
  cost_total: z.number().int().min(0),
  client_invoice_count: z.number().int().min(0),
  business_invoice_count: z.number().int().min(0),
});
export type BackfillTotals = z.infer<typeof BackfillTotalsSchema>;

export const BackfillClassificationResponseSchema = z.object({
  continue: z.boolean(),
  next_cursor: z.string().uuid().nullable(),
  processed_in_batch: z.number().int().min(0),
  succeeded_in_batch: z.number().int().min(0),
  failed_in_batch: z.number().int().min(0),
  totals_so_far_in_db: BackfillTotalsSchema,
  failures_in_batch: BackfillFailureReasonSchema,
  failed_invoice_ids: z.array(z.string().uuid()).max(200),
});
export type BackfillClassificationResponse = z.infer<typeof BackfillClassificationResponseSchema>;
